import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";
import { BankCountryConfig} from '../models/bank.model';
import { Supplier, SupplierBank} from '../models/supplier.model';
import { getSupplierBankMaster } from 'app/shared/utils/utils';
import { AddAccountArgs, VerifyAccountArgs } from '@tesla/payout-react';
import { LanguageService } from 'app/core/services/language.service';
import { EventService } from './event.service';
import { Event } from '../models/event.model';
import { AppSettings } from "../../app.settings";

@Injectable()
export class BankService extends BaseService {
    PAYOUT_CHANNEL = 'SUPPLIER_PORTAL';

    constructor(private http: HttpClient,
        private languageService: LanguageService,
        private config: AppSettings,
        private eventService: EventService) {
        super();
    }

    signIn(supplierCode: string, countryCode: string, currencyCode: string) {
        const url = `${this.config.BaseUrl}Profile/Bank/${supplierCode}/${countryCode}/${currencyCode}/signIn`;
        return this.http.get<string>(url, { headers: this.setHeaders() });
    }

    getVerificationKeys(supplierCode: string) {
        const url = `${this.config.BaseUrl}Profile/Bank/${supplierCode}/verificationKeys`;
        return this.http.get<any>(url, { headers: this.setHeaders() });
    }

    getBankCountries(supplierCode: string): Observable<BankCountryConfig[]> {
        const url = `${this.config.BaseUrl}Profile/Bank/${supplierCode}/Countries`;
        return this.http.get<BankCountryConfig[]>(url, { headers: this.setHeaders() });
    }

    fetchBankMetaData(supplierCode: string): Observable<SupplierBank> {
        const url = `${this.config.BaseUrl}Profile/Bank/${supplierCode}/FetchBankMetadata`;
        return this.http.get<SupplierBank>(url, { headers: this.setHeaders() }).map(x => getSupplierBankMaster(x));
    }

    verifyBank(supplierCode: string, bankNickName: string) {
        const url = `${this.config.BaseUrl}Profile/Bank/${supplierCode}/VerifyBank`;
        return this.http.post<boolean>(url, { bankNickName }, { headers: this.setHeaders() });
    }

    getAddAccountArgs(countryCode: string, currencyCode: string, signedToken: string) {
        const args: AddAccountArgs = {
            countryCode: countryCode,
            currencyCode: currencyCode,
            locale: this.languageService.getSelectedLanguage().replace('-', '_'),
            returnUrl: this.config.SupplierPortalUrl,
            signedData: signedToken,
            paymentChannel: this.PAYOUT_CHANNEL,
            user: null,
            billingAddress: null,
            billingContact: null
        };

        return args;
    }

    getVerifyArgs(signedToken: string, instrumentReference: string) {
        const args: VerifyAccountArgs = {
            countryCode: 'US',
            currencyCode: 'USD',
            locale: this.languageService.getSelectedLanguage().replace('-', '_'),
            returnUrl: this.config.SupplierPortalUrl,
            signedData: signedToken,
            paymentChannel: this.PAYOUT_CHANNEL,
            user: null,
            billingAddress: null,
            billingContact: null,
            instrumentId: instrumentReference
        };

        return args;
    }

    saveDraftBank(supplierCode: string, supplierBank: SupplierBank) {
        const event = new Event();
        event.Name = 'Bank Saved';
        event.Properties = supplierBank;
        event.ReferenceIdentifier = supplierCode;
        return this.eventService.PostEvent(event);
    }
    validateIban(supplierCode: string, input: any): Observable<string[]> {
        const url = `${this.config.BaseUrl}Profile/Bank/ValidateIban/${supplierCode}`;
        return this.http.post<string[]>(url, input);
      }

}